import { isTMA } from '@telegram-apps/sdk-react';

/** Открыты ли мы внутри Telegram (синхронная нестрогая проверка). */
export function insideTelegram(): boolean {
  try {
    return isTMA('simple');
  } catch {
    return false;
  }
}

/** Любой вызов SDK вне поддерживающего клиента кидает — глушим точечно. */
export function safe<T>(fn: () => T): T | undefined {
  try {
    return fn();
  } catch {
    return undefined;
  }
}
